(function(){
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function money(c, fmt){ c = Number(c) || 0; var a = c / 100; var s = (a % 1) ? a.toFixed(2) : String(a); return String(fmt || '${{amount}}').replace(/\{\{\s*[a-z_]+\s*\}\}/, s); }
  function qs(r, s){ return r.querySelector(s); }
  function qsa(r, s){ return Array.prototype.slice.call(r.querySelectorAll(s)); }
  function esc(s){ var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  var store = {
    get: function(k){ try { return JSON.parse(localStorage.getItem(k) || '[]') || []; } catch(e){ return []; } },
    set: function(k, v){ try { localStorage.setItem(k, JSON.stringify(v)); } catch(e){} }
  };
  function syncFavs(root){ var l = store.get('es-favs'); qsa(root, '[data-es-fav]').forEach(function(b){ b.classList.toggle('is-on', l.indexOf(b.getAttribute('data-es-fav')) > -1); }); }
  function updateCount(n){
    qsa(document, '.es-icons a[href$="/cart"]').forEach(function(a){
      var b = a.querySelector('.es-cart-count');
      if (!b){ b = document.createElement('b'); b.className = 'es-cart-count'; a.appendChild(b); }
      b.textContent = n;
    });
  }

  function setup(pdp){
    if (pdp.__es) return; pdp.__es = true;
    var data; try { data = JSON.parse(qs(pdp, '[data-es-json]').textContent); } catch(e){ return; }
    var P = data.product, fmt = data.fmt;
    var form = qs(pdp, 'form[action*="/cart/add"]');
    var vid = qs(pdp, '[data-es-vid]'), atc = qs(pdp, '[data-es-atc]'), atcLabel = qs(pdp, '[data-es-atc-label]');
    var opts = qsa(pdp, '[data-es-opt]');
    var stockEl = qs(pdp, '[data-es-stock]'), wa = qs(pdp, '[data-es-wa]'), bn = qs(pdp, '.es-bn');
    var sticky = document.querySelector('[data-es-sticky]');
    var low = data.low || 5;
    if (!form || !atc) return;

    function selected(){ return opts.map(function(o){ var c = qs(o, 'input:checked'); return c ? c.value : null; }); }
    function find(sel){
      if (!opts.length) return P.variants[0];
      if (sel.some(function(x){ return x === null; })) return null;
      for (var i = 0; i < P.variants.length; i++){ var v = P.variants[i]; if (v.options.every(function(x, j){ return x === sel[j]; })) return v; }
      return null;
    }
    function availability(sel){
      opts.forEach(function(o, i){
        qsa(o, '.es-sz').forEach(function(l){
          var val = qs(l, 'input').value;
          var ok = P.variants.some(function(v){
            if (!v.available || v.options[i] !== val) return false;
            return v.options.every(function(x, j){ return j === i || sel[j] === null || sel[j] === x; });
          });
          l.classList.toggle('is-out', !ok);
        });
      });
    }
    function stockMsg(v){
      if (!stockEl) return;
      stockEl.classList.remove('is-ok');
      if (!v){ stockEl.hidden = true; stockEl.innerHTML = ''; return; }
      stockEl.hidden = false;
      var inv = data.inv[v.id] || {};
      if (!v.available){ stockEl.innerHTML = 'Sold out' + (opts.length ? ' in this size — pick another or message us on WhatsApp' : ''); return; }
      if (inv.m === 'shopify' && inv.q > 0 && inv.q <= low){
        var w = Math.max(12, Math.min(100, inv.q * 14));
        stockEl.innerHTML = '<span>&#128293; Hurry! Only ' + inv.q + ' left' + (opts.length ? ' in this size' : '') + '</span><span class="bar"><i style="width:' + w + '%"></i></span>';
        return;
      }
      if (inv.m === 'shopify' && inv.q <= 0 && inv.p === 'continue'){ stockEl.innerHTML = 'Available to order — ships soon'; return; }
      stockEl.classList.add('is-ok'); stockEl.innerHTML = '&#10003; In stock — ready to ship';
    }

    function render(scrollMedia){
      var sel = selected(), v = find(sel);
      opts.forEach(function(o, i){ var b = qs(o, '[data-es-optval]'); if (b) b.textContent = sel[i] || data.tChoose; });
      availability(sel);
      var pv = v || P.variants.filter(function(x){ return x.available; })[0] || P.variants[0];
      var sale = pv.compare_at_price && pv.compare_at_price > pv.price;
      var now = qs(pdp, '[data-es-now]'), was = qs(pdp, '[data-es-was]'), save = qs(pdp, '[data-es-save]'), ob = qs(pdp, '[data-es-offbadge]');
      if (now){ now.textContent = money(pv.price, fmt); now.classList.toggle('sale', !!sale); }
      if (was){ was.hidden = !sale; if (sale) was.textContent = money(pv.compare_at_price, fmt); }
      if (save){ save.hidden = !sale; if (sale) save.textContent = 'Save ' + money(pv.compare_at_price - pv.price, fmt); }
      if (ob){ ob.parentNode.hidden = !sale; if (sale) ob.textContent = 'Save ' + money(pv.compare_at_price - pv.price, fmt); }
      var sp = sticky && qs(sticky, '[data-es-sticky-price]');
      if (sp){ sp.textContent = money(pv.price, fmt); sp.classList.toggle('sale', !!sale); }
      if (v){
        vid.value = v.id;
        atc.disabled = !v.available;
        atcLabel.textContent = v.available ? data.tAdd : data.tSold;
        if (opts.length && window.history && history.replaceState){ try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch(e){} }
        if (scrollMedia && v.featured_media) goToMedia(v.featured_media.id);
        opts.forEach(function(o){ var h = qs(o, '[data-es-hint]'); if (h) h.hidden = true; });
      } else {
        atc.disabled = false;
        atcLabel.textContent = data.tSelect;
      }
      if (bn) bn.classList.toggle('is-locked', !v);
      var sb = sticky && qs(sticky, '[data-es-sticky-atc]');
      if (sb){ sb.textContent = v ? (v.available ? data.tAdd : data.tSold) : data.tSelect; sb.disabled = !!(v && !v.available); }
      stockMsg(v);
      if (wa){
        var t = String(data.waText || '').replace('{product}', P.title).replace('{size}', v ? v.title : '-').replace('{price}', money(pv.price, fmt)).replace('{url}', data.url + (v && opts.length ? '?variant=' + v.id : ''));
        wa.href = 'https://wa.me/' + data.wa + '?text=' + encodeURIComponent(t);
      }
      return v;
    }

    function prompt(){
      var sel = selected();
      for (var i = 0; i < opts.length; i++){
        if (sel[i] === null){
          var o = opts[i], h = qs(o, '[data-es-hint]');
          if (h) h.hidden = false;
          o.classList.remove('is-shake'); void o.offsetWidth; o.classList.add('is-shake');
          o.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
      }
    }

    function showAdded(item, cart){
      var box = document.querySelector('[data-es-added]');
      if (!box){ location.href = ROOT + 'cart'; return; }
      var img = (item.featured_image && item.featured_image.url) || item.image;
      if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=240';
      qs(box, '[data-es-added-item]').innerHTML = (img ? '<img src="' + esc(img) + '" alt="">' : '') +
        '<div><b>' + esc(item.product_title) + '</b>' + (item.variant_title ? '<span>' + esc((P.options[0] || '') + ': ' + item.variant_title) + '</span>' : '') +
        '<span>Qty ' + item.quantity + '</span><strong>' + money(item.final_line_price, fmt) + '</strong></div>';
      qs(box, '[data-es-added-count]').textContent = cart.item_count;
      qs(box, '[data-es-added-total]').textContent = money(cart.total_price, fmt);
      var ship = qs(box, '[data-es-ship]');
      if (ship && data.free > 0){
        var rem = data.free - cart.total_price, p = Math.min(100, Math.round(cart.total_price * 100 / data.free));
        ship.innerHTML = (rem > 0 ? 'You are <b>' + money(rem, fmt) + '</b> away from <b>free delivery</b>' : '&#127881; You unlocked <b>free delivery</b>!') + '<span class="bar"><i style="width:' + p + '%"></i></span>';
      }
      updateCount(cart.item_count);
      document.body.classList.add('es-added-open');
      box.setAttribute('aria-hidden', 'false');
    }

    function add(v){
      var qi = qs(pdp, 'input[name="quantity"]'), q = qi ? (parseInt(qi.value, 10) || 1) : 1;
      var err = qs(pdp, '[data-es-error]'); if (err) err.hidden = true;
      atc.classList.add('is-loading'); atc.disabled = true;
      fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [{ id: v.id, quantity: q }] }) })
        .then(function(r){ return r.json().then(function(j){ return { ok: r.ok, j: j }; }); })
        .then(function(res){
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to cart, please try again.');
          var item = res.j.items ? res.j.items[0] : res.j;
          return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }).then(function(cart){ showAdded(item, cart); });
        })
        .catch(function(e){ if (err){ err.textContent = e.message; err.hidden = false; } else { alert(e.message); } })
        .then(function(){ atc.classList.remove('is-loading'); render(false); });
    }

    opts.forEach(function(o){ o.addEventListener('change', function(){ render(true); }); });
    qsa(pdp, '[data-es-qty]').forEach(function(b){
      b.addEventListener('click', function(){ var i = qs(pdp, 'input[name="quantity"]'); i.value = Math.max(1, (parseInt(i.value, 10) || 1) + (+b.getAttribute('data-es-qty'))); });
    });
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var v = find(selected());
      if (!v){ prompt(); return; }
      if (v.available) add(v);
    });
    if (bn) bn.addEventListener('click', function(e){ if (!find(selected())){ e.preventDefault(); e.stopPropagation(); prompt(); } }, true);

    // Gallery
    var track = qs(pdp, '[data-es-track]'), thumbs = qsa(pdp, '[data-es-thumb]'), cnt = qs(pdp, '[data-es-gcount]');
    function idx(){ return track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0; }
    function go(i){ if (!track) return; var n = track.children.length; i = ((i % n) + n) % n; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
    function goToMedia(id){ if (!track) return; var s = qsa(track, '[data-media-id]'); for (var i = 0; i < s.length; i++){ if (String(s[i].getAttribute('data-media-id')) === String(id)){ go(i); return; } } }
    if (track){
      var tm;
      track.addEventListener('scroll', function(){
        clearTimeout(tm);
        tm = setTimeout(function(){
          var i = idx();
          thumbs.forEach(function(t, j){ t.classList.toggle('is-on', j === i); });
          var th = thumbs[i];
          if (th){ var c = th.parentNode; c.scrollTo({ left: th.offsetLeft - c.clientWidth / 2 + th.clientWidth / 2, top: th.offsetTop - c.clientHeight / 2 + th.clientHeight / 2, behavior: 'smooth' }); }
          if (cnt) cnt.textContent = i + 1;
        }, 60);
      }, { passive: true });
    }
    thumbs.forEach(function(t){ t.addEventListener('click', function(){ go(+t.getAttribute('data-es-thumb')); }); });
    qsa(pdp, '[data-es-gnav]').forEach(function(b){ b.addEventListener('click', function(){ go(idx() + (+b.getAttribute('data-es-gnav'))); }); });

    // Sticky bar
    if (sticky){
      if ('IntersectionObserver' in window){
        new IntersectionObserver(function(es){ var e = es[0]; sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); }, { threshold: 0 }).observe(atc);
      }
      var sb = qs(sticky, '[data-es-sticky-atc]');
      if (sb) sb.addEventListener('click', function(){ var v = find(selected()); if (!v){ prompt(); return; } if (v.available) add(v); });
    }

    // Delivery estimate
    var eta = qs(pdp, '[data-es-eta-dates]');
    if (eta){
      var box = eta.closest('[data-es-eta]'), mn = +box.getAttribute('data-min') || 1, mx = +box.getAttribute('data-max') || mn;
      var addDays = function(n){ var d = new Date(), c = 0; while (c < n){ d.setDate(d.getDate() + 1); if (d.getDay() !== 0) c++; } return d; };
      var o = { weekday: 'short', day: 'numeric', month: 'short' };
      try { var a = addDays(mn).toLocaleDateString('en-GB', o), b = addDays(mx).toLocaleDateString('en-GB', o); eta.textContent = mn === mx ? a : a + ' – ' + b; } catch(e){}
    }

    // Recently viewed
    var rec = store.get('es-recent').filter(function(h){ return h && h !== P.handle; });
    rec.unshift(P.handle); store.set('es-recent', rec.slice(0, 16));

    render(false);
  }

  function loadRecs(){
    qsa(document, '[data-es-recs]').forEach(function(s){
      if (s.__l) return; s.__l = 1;
      var url = s.getAttribute('data-url'); if (!url) return;
      fetch(url).then(function(r){ return r.text(); }).then(function(h){
        var d = document.createElement('div'); d.innerHTML = h;
        var n = d.querySelector('[data-es-recs]');
        if (n && n.querySelector('.es-card')){ s.innerHTML = n.innerHTML; s.hidden = false; syncFavs(s); } else { s.hidden = true; }
      }).catch(function(){});
    });
  }
  function loadRecent(){
    qsa(document, '[data-es-recent]').forEach(function(s){
      if (s.__l) return; s.__l = 1;
      var cur = s.getAttribute('data-current'), lim = +s.getAttribute('data-limit') || 8;
      var list = store.get('es-recent').filter(function(h){ return h && h !== cur; }).slice(0, lim);
      if (!list.length) return;
      var tr = s.querySelector('[data-es-recent-track]');
      Promise.all(list.map(function(h){ return fetch(ROOT + 'products/' + encodeURIComponent(h) + '?view=es-card').then(function(r){ return r.ok ? r.text() : ''; }).catch(function(){ return ''; }); }))
        .then(function(arr){ var html = arr.filter(function(x){ return x.indexOf('es-card') > -1; }).join(''); if (html && tr){ tr.innerHTML = html; s.hidden = false; syncFavs(s); } });
    });
  }

  function closeAdded(){ document.body.classList.remove('es-added-open'); var b = document.querySelector('[data-es-added]'); if (b) b.setAttribute('aria-hidden', 'true'); }
  function closeLb(){ var lb = document.querySelector('[data-es-lb].is-open'); if (lb){ lb.classList.remove('is-open'); document.documentElement.style.overflow = ''; } }
  document.addEventListener('click', function(e){
    var t = e.target; if (!t || !t.closest) return;
    if (t.closest('[data-es-added-close]') || (t.classList.contains('es-overlay') && document.body.classList.contains('es-added-open'))){ closeAdded(); return; }
    var m = t.closest('[data-es-modal]');
    if (m){ var d = document.getElementById(m.getAttribute('data-es-modal')); if (d && d.showModal){ d.showModal(); } return; }
    if (t.closest('[data-es-modal-close]')){ var dd = t.closest('dialog'); if (dd) dd.close(); return; }
    if (t.tagName === 'DIALOG' && t.close){ t.close(); return; }
    var z = t.closest('[data-es-zoom]');
    if (z){ var lb = document.querySelector('[data-es-lb]'); if (lb){ lb.querySelector('img').src = z.getAttribute('data-es-zoom'); lb.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; } return; }
    if (t.closest('[data-es-lb]')) closeLb();
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape'){ closeAdded(); closeLb(); } });

  function init(){ qsa(document, '[data-es-pdp]').forEach(setup); loadRecs(); loadRecent(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
